import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Menu from "./components/menu/Menu";
import Data from "./components/afas/Afas";
import UserManagement from "./components/user_management/Users";
import { useAuth } from "./context/AuthContext";
import Add from "./components/user_management/AddUser";
import LoginPage from "./components/login/Login";
import NoAccessPage from "./components/no_access/NoAccess";
import PrivateRoute from "./components/routes/PrivateRoute";

import "./App.css";

const App = () => {
  const { isAuthenticated, userRole, userData, loading } = useAuth();
  const location = useLocation();

  const isOnNoAccessPage = location.pathname === "/no-access";

  const roleLoaded = userRole !== null && userRole !== undefined;
  const ready = !loading && (!isAuthenticated || roleLoaded);

  if (!ready) {
    return (
      <>
        <Menu />
        <div className="main">{/* Optional: spinner of skeleton */}</div>
      </>
    );
  }

  // ✅ pas als alles geladen is mag je beoordelen of gebruiker toegang heeft
  const hasAccess = isAuthenticated && roleLoaded;

  return (
    <>
      <Menu />
      <div className="main-container">
        {!hasAccess && !isOnNoAccessPage ? (
          <LoginPage />
        ) : (
          <Routes>
            <Route path="/" element={<Navigate to="/afas" replace />} />
            <Route
              path="/afas"
              element={
                <PrivateRoute user={userData}>
                  <Data />
                </PrivateRoute>
              }
            />
            <Route
              path="/users"
              element={
                <PrivateRoute allowedRoles={["Admin"]}>
                  <UserManagement />
                </PrivateRoute>
              }
            />
            <Route
              path="/add"
              element={
                <PrivateRoute user={userData}>
                  <Add />
                </PrivateRoute>
              }
            />
            <Route path="/" element={<LoginPage />} />
            <Route path="/no-access" element={<NoAccessPage />} />
            <Route path="*" element={<NoAccessPage />} />
          </Routes>
        )}
      </div>
    </>
  );
};

export default App;
